import { $locked, report, setup } from './model/location'

export const $$security = { setup, report, $locked }
